import { Injectable } from '@angular/core';
import {DateUtils} from '../../_commons/date-utils';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';


@Injectable({
  providedIn: 'root'
})
export class InputService {

  constructor(private dateUtils: DateUtils) { }

  getNumberOfDays(fromDate: string, toDate: string): number {
    let numDay = 0;
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      numDay = this.dateUtils.diffHours(from, to) / 24;
      return Math.ceil(numDay);
    }
    return numDay;
  }

  saveNumberOfDays(key: string, numberOfDay: number) {
    localStorage.setItem(key,  String(numberOfDay));
  }

  getDefaultDate(key: string): NgbDateStruct {
    return JSON.parse(localStorage.getItem(key));
  }

  saveDefaultDate(key: string, date: NgbDateStruct) {
    localStorage.setItem(key, JSON.stringify(date));
  }
}
